<template>
  <div />
</template>

<script>
import { defineComponent } from 'vue';

import { Logger } from '../mixins/logger';

export default defineComponent({
  name: 'StarbucksChatUI',
  mixins: [Logger],

  mounted() {
    const initESW = function (gslbBaseURL) {
      window.embedded_svc.settings.displayHelpButton = true;
      window.embedded_svc.settings.language = 'en-US';
      window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      window.embedded_svc.settings.entryFeature = 'LiveAgent';
      window.embedded_svc.settings.extraPrechatFormDetails = [
        {
          label: 'LeadClassFromPreChatForm',
          value: 'CORP',
          displayToAgent: false,
          transcriptFields: ['LeadClassFromPreChatForm__c']
        },
        {
          label: 'LeadSubClassFromPreChatForm',
          value: 'scap',
          displayToAgent: false,
          transcriptFields: ['LeadSubClassFromPreChatForm__c']
        }
      ];
      window.embedded_svc.settings.extraPrechatInfo = [
        {
          entityFieldMaps: [
            {
              doCreate: true,
              doFind: true,
              fieldName: 'ASUO_Lead_Class__c',
              isExactMatch: true,
              label: 'LeadClassFromPreChatForm'
            },
            {
              doCreate: true,
              doFind: true,
              fieldName: 'ASUO_Lead_SubClass__c',
              isExactMatch: true,
              label: 'LeadSubClassFromPreChatForm'
            }
          ],
          entityName: 'Contact'
        }
      ];
      window.embedded_svc.init(
        import.meta.env.VITE_SALESFORCE_LIVE_AGENT,
        import.meta.env.VITE_SALESFORCE_LIVE_AGENT_IDEAS,
        gslbBaseURL,
        import.meta.env.VITE_SALESFORCE_LIVE_AGENT_ID,
        // '00D530000008aQs',
        'P2A_Chat_Deployment',
        {
          baseLiveAgentContentURL: import.meta.env.VITE_SALESFORCE_LIVE_AGENT_BASE_LIVE_AGENT_CONTENT_URL,
          deploymentId: import.meta.env.VITE_SALESFORCE_LIVE_AGENT_DEPLOYMENT_ID,
          buttonId: import.meta.env.VITE_SALESFORCE_LIVE_AGENT_BUTTON_ID,
          baseLiveAgentURL: import.meta.env.VITE_SALESFORCE_LIVE_AGENT_BASE_LIVE_AGENT_URL,
          eswLiveAgentDevName: import.meta.env.VITE_SALESFORCE_LIVE_AGENT_ESW_LIVE_AGENT_DEV_NAME,
          isOfflineSupportEnabled: true
        }
      );
    };
    if (!window.embedded_svc) {
      var s = document.createElement('script');
      s.setAttribute('src', `${import.meta.env.VITE_SALESFORCE_LIVE_AGENT}/embeddedservice/5.0/esw.min.js`);
      s.onload = function () {
        initESW(null);
      };
      document.body.appendChild(s);
    } else {
      initESW('https://service.force.com');
    }
  }
});
</script>

<style lang="scss">
div.buttonWrapper.embeddedServiceSidebarForm > button {
  span {
    background-color: transparent;
  }
}
header > button.closeButton {
  padding: 4px 0 0 0;
}
</style>
